export default function Contact() {
    return <>

        <div className="max-w-7xl px-4 sm:px-6 lg:px-8 py-12 lg:py-24 mx-auto">
            <div className="mb-6 sm:mb-10 max-w-2xl text-center mx-auto">
                <h2 className="font-medium text-foreground text-2xl sm:text-4xl">
                    Kontak
                </h2>
            </div>

            <div className="max-w-4xl mx-auto flex flex-col sm:flex-row sm:justify-between gap-4 sm:gap-6">
                <div className="flex-1 rounded-2xl border border-card-line bg-card p-6 sm:p-8 text-center">
                    <p className="text-sm text-muted-foreground-1">WhatsApp</p>
                    <a
                        href="https://wa.me/6283191910986"
                        target="_blank"
                        rel="noreferrer"
                        className="mt-2 inline-block text-xl sm:text-2xl font-semibold text-foreground hover:text-primary-hover"
                    >
                        +62 831-9191-0986
                    </a>
                    <p className="mt-2 text-sm text-muted-foreground-1">Respons Cepat</p>
                </div>

                <div className="flex-1 rounded-2xl border border-card-line bg-card p-6 sm:p-8 text-center">
                    <p className="text-sm text-muted-foreground-1">Email</p>
                    <a
                        href="mailto:nitnotstore20@gmail.com"
                        className="mt-2 inline-block text-base sm:text-lg font-medium text-foreground hover:text-primary-hover"
                    >
                        nitnotstore20@gmail.com
                    </a>
                </div>
            </div>
        </div>
    </>
}
